export type RecoveryMode = 'revise' | 'redirect' | 'freight' | 'cancel'

export const RECOVERY_OPTION_MODES: Record<string, RecoveryMode> = {
  revise_line_item: 'revise',
  redirect_contact: 'redirect',
  accept_freight_charge: 'freight',
  record_cancellation: 'cancel',
}

export type RecoveryPrefill = {
  recipientEmail?: string
  recipientName?: string
  replyBody?: string
}

/** Freight and cancellation are quick confirmations in a popover; revise and redirect stay inline (USA-1536). */
export type PopoverRecoveryMode = Extract<RecoveryMode, 'freight' | 'cancel'>
export type InlineRecoveryMode = Exclude<RecoveryMode, PopoverRecoveryMode>

export function isPopoverRecovery(mode: string | null): mode is PopoverRecoveryMode {
  return mode === 'freight' || mode === 'cancel'
}
